<template>
  <div class="filter-pane">
    <div class="container">
      <el-popover popper-class="filter-tip-content-popper" trigger="hover" placement="bottom-start">
        <div class="filter-tip-content" slot="reference">
          <span>课题筛选条件</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <searchInfo :list="courseConditionArr" :instrumentType="instrumentType" />
      </el-popover>
      <div class="pane-content">
        <div class="filter-content" :style="showMore ? {} : { maxHeight: '68px', overflow: 'hidden' }">
          <div class="content" ref="content">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
    <div v-if="over" class="expand-content" @click="showMore = !showMore">
      <template v-if="showMore">
        <i class="iconfont iconshouqi"></i>
        <span class="expand-text">收起</span>
      </template>
      <template v-else>
        <i class="iconfont iconzhankai"></i>
        <span class="expand-text">展开</span>
      </template>
    </div>
  </div>
</template>

<script>
import elementResizeDetectorMaker from 'element-resize-detector';
import searchInfo from '@/components/searchInfo';

export default {
  components: { searchInfo },
  data() {
    return {
      showMore: false,
      over: false
    };
  },
  props: {
    courseConditionArr: {
      type: Array,
      default: () => []
    },
    instrumentType: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.resizeHandle();
  },
  methods: {
    resizeHandle() {
      const erd = elementResizeDetectorMaker();
      erd.listenTo(this.$refs.content, element => {
        this.over = element.offsetHeight > 68;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-pane {
  box-sizing: border-box;
  position: relative;
  padding: 3px 0 2px;

  .container {
    display: flex;
    align-items: flex-start;
    padding: 10px 10px 0 10px;

    .filter-tip-content {
      font-size: 12px;
      color: rgba(#2c3443, 0.8);
      height: 24px;
      line-height: 24px;
      margin-right: 10px;
      margin-bottom: 7px;
      // padding-left: 14px;
      cursor: default;

      .iconfont {
        font-size: 14px;
        margin-right: 6px;
      }
    }

    .pane-content {
      flex: 1;
      width: 0;
      .filter-content {
        width: 100%;
      }
    }
  }

  .expand-content {
    box-sizing: border-box;
    text-align: center;
    padding: 8px 0;
    cursor: pointer;
    color: #77839e;
    font-size: 12px;

    .iconfont {
      font-size: 12px;
      margin-right: 3px;
    }

    .expand-text {
      display: none;
    }

    &:hover {
      color: #1991fb;
      background-color: #f5f7fa;
      .expand-text {
        display: inline;
      }
    }
  }
}
</style>

<style>
.filter-tip-content-popper {
  width: calc(100% - 540px);
  max-height: 500px;
  overflow: scroll;
}
</style>
